import {Directive, ElementRef, input, OnDestroy, output} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";

const debug = initDebugger('BekreftKlikkDirektiv');

/**
 * Viser tekst angitt via bekreftKlikk ved første klikk,
 * emitter klikk ved neste klikk
 *
 * Eks: `<button mat-button [bekreftKlikk]="'klikk en gang til'" (klikk)="handling()">En knapp</button>`
 */
@Directive({
    selector: 'button[bekreftKlikk]',
    host: {'(click)': 'clickEvent($event)'},
    standalone: true
})
export class BekreftKlikkDirektiv implements OnDestroy {

    /** antall millisekunder vi venter fra første klikk til vi returnerer til opprinnelig knappetekst */
    static readonly bekreftKlikkTimeout = 1000 * 5;
    /** antall millisekunder vi venter fra første klikk vi lar påfølgende klikk propagere til klikk emitter */
    static readonly klikkUndertrykkInterval = 500;

    klikk = output<MouseEvent>();

    /** Tekst som vises i stede for eksisterende label når bruker klikker */
    bekreftLabelTekst = input.required<string>({alias: 'bekreftKlikk'});

    private bekreftLabelElement: HTMLSpanElement | null = null;
    private buttonLabelElement: HTMLSpanElement | null = null;
    private bekreftKlikkTimeout: number | null = null;
    private venterPåBekreftKlikk = false;
    private undertrykkKlikk = false;

    constructor(private el: ElementRef<HTMLButtonElement>) {
    }

    clickEvent(event: MouseEvent): void {
        if (this.undertrykkKlikk) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        if (!this.venterPåBekreftKlikk) {
            event.preventDefault();
            event.stopPropagation();
            this.bekreft();
        } else {
            //utfør klikk
            this.avbrytBekreft();
            this.klikk.emit(event);
        }
    }

    ngOnDestroy(): void {
        this.avbrytBekreftKlokkTimeout();
    }

    // private hjelpemetoder

    private bekreft() {
        if (this.bekreftLabelElement == null) this.leggTilBekreftLabelElementer();
        this.venterPåBekreftKlikk = true;
        this.bekreftLabelElement!.hidden = false;
        this.buttonLabelElement!.hidden = true
        this.el.nativeElement.classList.add('bekreftKlikk--bekreft');

        //undertrykk nye klikk for en periode
        this.undertrykkKlikk = true;
        window.setTimeout(() => this.undertrykkKlikk = false, BekreftKlikkDirektiv.klikkUndertrykkInterval);

        //returner til opprinnelig label etter en viss tid
        this.bekreftKlikkTimeout = window.setTimeout(() => this.avbrytBekreft(), BekreftKlikkDirektiv.bekreftKlikkTimeout);
    }

    private avbrytBekreft() {
        this.venterPåBekreftKlikk = false;
        this.bekreftLabelElement!.hidden = true;
        this.buttonLabelElement!.hidden = false;
        this.el.nativeElement.classList.remove('bekreftKlikk--bekreft');
        this.avbrytBekreftKlokkTimeout();
    }

    private avbrytBekreftKlokkTimeout() {
        if (erIkkeNil(this.bekreftKlikkTimeout)) window.clearTimeout(this.bekreftKlikkTimeout);
    }

    private leggTilBekreftLabelElementer() {
        this.buttonLabelElement =
          this.el.nativeElement.querySelector('.mdc-button__label') //<button mat-button
          || this.el.nativeElement.querySelector('.mat-mdc-menu-item-text');  //<button mat-menu-item
        this.bekreftLabelElement = document.createElement('span');
        this.bekreftLabelElement.classList.add('bekreftKlikk--label')
        this.bekreftLabelElement.setAttribute('data-testid', 'sp-bekreft')
        this.bekreftLabelElement.hidden = true;
        this.bekreftLabelElement.innerHTML = this.bekreftLabelTekst();
        this.el.nativeElement.insertBefore(this.bekreftLabelElement, this.buttonLabelElement);
    }
}
